
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vefverslun/um-voru/[productid]",
      function () {
        return require("private-next-pages/vefverslun/um-voru/[productid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vefverslun/um-voru/[productid]"])
      });
    }
  